<template>
  <el-container class="admin-shell">
    <div v-if="isMobile && mobileMenuOpen" class="admin-aside-mask" @click="mobileMenuOpen = false"></div>
    <el-aside width="232px" class="admin-aside" :class="{ 'mobile-layout': isMobile, 'mobile-open': mobileMenuOpen }">
      <div class="brand">
        <span class="brand-mark">旅</span>
        <div>
          <strong>惠享京程</strong>
          <small>业务管理后台</small>
        </div>
      </div>
      <el-menu
        class="side-menu"
        router
        :default-active="$route.path"
        background-color="#15171c"
        text-color="#c8ccd4"
        active-text-color="#ffffff"
        @select="closeMobileMenu"
      >
        <el-menu-item index="/dashboard">
          <i class="el-icon-data-analysis"></i>
          <span slot="title">工作台总览</span>
        </el-menu-item>
        <el-menu-item v-if="canAccess('home-configs')" index="/content/home">
          <i class="el-icon-house"></i>
          <span slot="title">首页主视觉</span>
        </el-menu-item>
        <el-menu-item v-if="canAccess('routes')" index="/content/routes">
          <i class="el-icon-map-location"></i>
          <span slot="title">线路管理</span>
        </el-menu-item>
        <el-menu-item v-if="canAccess('route-plans')" index="/content/route-plans">
          <i class="el-icon-tickets"></i>
          <span slot="title">方案模板管理</span>
        </el-menu-item>
        <el-menu-item v-if="canAccess('scenic-spots')" index="/content/scenic-spots">
          <i class="el-icon-location-outline"></i>
          <span slot="title">景点管理</span>
        </el-menu-item>
        <el-menu-item v-if="canAccess('hotels')" index="/content/hotels">
          <i class="el-icon-office-building"></i>
          <span slot="title">酒店管理</span>
        </el-menu-item>
        <el-menu-item v-if="canAccess('food-items')" index="/content/foods">
          <i class="el-icon-dish"></i>
          <span slot="title">美食推荐</span>
        </el-menu-item>
        <el-menu-item v-if="canAccess('culture-experiences')" index="/content/culture">
          <i class="el-icon-school"></i>
          <span slot="title">文化体验</span>
        </el-menu-item>
        <el-menu-item v-if="canAccess('inspiration-items')" index="/inspirations">
          <i class="el-icon-collection"></i>
          <span slot="title">灵感探索管理</span>
        </el-menu-item>
        <el-menu-item v-if="canAccess('consultations')" index="/business/consultations">
          <i class="el-icon-chat-dot-round"></i>
          <span slot="title" class="consultation-menu-title">
            <span>咨询管理</span>
            <span v-if="unreadTotal" class="menu-unread-badge">{{ unreadLabel }}</span>
          </span>
        </el-menu-item>
        <el-menu-item v-if="canAccess('basic-service-config')" index="/content/basic-service">
          <i class="el-icon-service"></i>
          <span slot="title">基础服务管理</span>
        </el-menu-item>
        <el-menu-item v-if="canAccess('custom-service-config')" index="/content/custom-service">
          <i class="el-icon-suitcase"></i>
          <span slot="title">高端定制管理</span>
        </el-menu-item>
        <el-menu-item v-if="canAccess('service-need-options')" index="/content/service-options">
          <i class="el-icon-set-up"></i>
          <span slot="title">服务选项</span>
        </el-menu-item>
        <el-menu-item v-if="canAccess('users')" index="/customers/users">
          <i class="el-icon-user"></i>
          <span slot="title">小程序用户</span>
        </el-menu-item>
        <el-menu-item v-if="canAccess('recommenders')" index="/business/recommenders">
          <i class="el-icon-share"></i>
          <span slot="title">推荐官管理</span>
        </el-menu-item>
        <el-menu-item v-if="canAccess('staff')" index="/team/staff">
          <i class="el-icon-service"></i>
          <span slot="title">后台管理</span>
        </el-menu-item>
        <el-menu-item v-if="canAccess('custom-demands')" index="/business/custom-demands">
          <i class="el-icon-s-order"></i>
          <span slot="title">定制需求</span>
        </el-menu-item>
        <el-menu-item v-if="canAccess('service-orders') || canAccess('consult-orders')" index="/business/service-orders">
          <i class="el-icon-document"></i>
          <span slot="title">服务订单</span>
        </el-menu-item>
        <el-menu-item v-if="canAccess('payments')" index="/business/payments">
          <i class="el-icon-bank-card"></i>
          <span slot="title">支付记录</span>
        </el-menu-item>
        <el-menu-item v-if="canAccess('reviews')" index="/business/reviews">
          <i class="el-icon-star-off"></i>
          <span slot="title">评价审核</span>
        </el-menu-item>
        <el-menu-item v-if="canAccess('settings')" index="/system/settings">
          <i class="el-icon-setting"></i>
          <span slot="title">系统参数</span>
        </el-menu-item>
        <el-menu-item v-if="canAccess('agreement-versions')" index="/system/agreements">
          <i class="el-icon-document-checked"></i>
          <span slot="title">协议版本管理</span>
        </el-menu-item>
      </el-menu>
    </el-aside>

    <el-container>
      <el-header class="admin-header" height="64px">
        <div class="header-leading">
          <el-button v-if="isMobile" class="mobile-menu-button" icon="el-icon-menu" circle @click="mobileMenuOpen = true" />
          <el-breadcrumb separator="/">
            <el-breadcrumb-item>管理后台</el-breadcrumb-item>
            <el-breadcrumb-item>{{ pageTitle }}</el-breadcrumb-item>
          </el-breadcrumb>
        </div>
        <div class="account">
          <el-button type="text" :icon="soundEnabled ? 'el-icon-bell' : 'el-icon-close-notification'" @click="toggleSound">
            {{ soundEnabled ? '提示音已开' : '提示音已关' }}
          </el-button>
          <span>管理员</span>
          <el-button type="text" @click="logout">退出登录</el-button>
        </div>
      </el-header>
      <el-main class="admin-main">
        <router-view />
      </el-main>
    </el-container>
  </el-container>
</template>

<script>
import { getCurrentUser, logout } from "../api/auth";
import http from "../api/http";
import { connect, disconnect, subscribe } from "../utils/realtime";

export default {
  name: "AdminLayout",
  data() {
    let currentAdmin = {};
    try { currentAdmin = JSON.parse(window.localStorage.getItem("admin_user") || "{}"); } catch (error) { currentAdmin = {}; }
    return {
      currentAdmin,
      unreadTotal: 0,
      unreadRefreshTimer: null,
      isMobile: false,
      mobileMenuOpen: false,
      soundEnabled: window.localStorage.getItem("consultation_sound_enabled") !== "false",
      audioContext: null
    };
  },
  mounted() {
    this.updateViewport();
    window.addEventListener("resize", this.updateViewport);
    this.refreshCurrentAdmin();
    this.unsubscribeRealtime = subscribe(this.handleRealtimeEvent);
    connect();
    this.refreshUnreadTotal();
  },
  beforeDestroy() {
    window.removeEventListener("resize", this.updateViewport);
    if (this.unsubscribeRealtime) this.unsubscribeRealtime();
    if (this.unreadRefreshTimer) window.clearTimeout(this.unreadRefreshTimer);
    disconnect();
  },
  computed: {
    pageTitle() {
      return this.$route.meta.title || "业务管理";
    },
    unreadLabel() {
      return this.unreadTotal > 99 ? "99+" : String(this.unreadTotal);
    }
  },
  methods: {
    handleRealtimeEvent(payload) {
      if (!payload || !["consultation.message", "consultation.read", "realtime.connected"].includes(payload.event)) return;
      if (payload.event === "consultation.message" && payload.data && payload.data.message && payload.data.message.sender_type === "user") {
        this.playMessageSound();
      }
      if (this.unreadRefreshTimer) window.clearTimeout(this.unreadRefreshTimer);
      this.unreadRefreshTimer = window.setTimeout(() => {
        this.unreadRefreshTimer = null;
        this.refreshUnreadTotal();
      }, 80);
    },
    updateViewport() {
      this.isMobile = window.innerWidth <= 768;
      if (!this.isMobile) this.mobileMenuOpen = false;
    },
    closeMobileMenu() {
      if (this.isMobile) this.mobileMenuOpen = false;
    },
    toggleSound() {
      this.soundEnabled = !this.soundEnabled;
      window.localStorage.setItem("consultation_sound_enabled", String(this.soundEnabled));
      if (this.soundEnabled) this.playMessageSound();
    },
    playMessageSound() {
      if (!this.soundEnabled) return;
      try {
        const AudioContext = window.AudioContext || window.webkitAudioContext;
        if (!AudioContext) return;
        if (!this.audioContext) this.audioContext = new AudioContext();
        if (this.audioContext.state === "suspended") this.audioContext.resume();
        const now = this.audioContext.currentTime;
        const oscillator = this.audioContext.createOscillator();
        const gain = this.audioContext.createGain();
        oscillator.type = "sine";
        oscillator.frequency.setValueAtTime(880, now);
        oscillator.frequency.setValueAtTime(1100, now + 0.1);
        gain.gain.setValueAtTime(0.0001, now);
        gain.gain.exponentialRampToValueAtTime(0.18, now + 0.015);
        gain.gain.exponentialRampToValueAtTime(0.0001, now + 0.24);
        oscillator.connect(gain);
        gain.connect(this.audioContext.destination);
        oscillator.start(now);
        oscillator.stop(now + 0.25);
      } catch (error) {
        // 浏览器未授权音频时保留角标提醒，不影响消息接收。
      }
    },
    async refreshUnreadTotal() {
      if (!this.canAccess("consultations")) return;
      try {
        const res = await http.get("/consultations/unread-summary", { showErrorMessage: false });
        this.unreadTotal = Number((res.data && res.data.unread_count) || 0);
      } catch (error) {
        // 角标失败不阻断后台其他功能。
      }
    },
    canAccess(moduleName) {
      const admin = this.currentAdmin || {};
      const permissions = admin.permissions || [];
      return admin.role_code === "super_admin" || permissions.includes("*:*")
        || permissions.includes(`${moduleName}:manage`) || permissions.includes(`${moduleName}:read`);
    },
    async refreshCurrentAdmin() {
      try {
        const res = await getCurrentUser();
        this.currentAdmin = (res.data && res.data.user) || {};
        window.localStorage.setItem("admin_user", JSON.stringify(this.currentAdmin));
        await this.refreshUnreadTotal();
      } catch (error) {
        this.currentAdmin = {};
      }
    },
    async logout() {
      try {
        await logout();
      } catch (error) {
        // 本地退出仍需清理 token，避免后端异常时卡住用户。
      }
      window.localStorage.removeItem("admin_token");
      window.localStorage.removeItem("admin_user");
      this.$router.replace("/login");
    }
  }
};
</script>

<style scoped>
.consultation-menu-title {
  display: inline-flex;
  align-items: center;
  justify-content: space-between;
  width: 158px;
}

.header-leading {
  display: flex;
  align-items: center;
  gap: 12px;
  min-width: 0;
}

.mobile-menu-button {
  flex: 0 0 auto;
}

.admin-aside-mask {
  position: fixed;
  inset: 0;
  z-index: 1998;
  background: rgba(15, 18, 24, 0.46);
}

.admin-aside.mobile-layout {
  position: fixed;
  top: 0;
  bottom: 0;
  left: 0;
  z-index: 1999;
  transform: translateX(-100%);
  transition: transform 0.2s ease;
}

.admin-aside.mobile-layout.mobile-open {
  transform: translateX(0);
}

@media (max-width: 768px) {
  .account > span {
    display: none;
  }

  .account {
    gap: 8px;
  }

  .account .el-button {
    padding-left: 4px;
    padding-right: 4px;
  }
}

.menu-unread-badge {
  min-width: 18px;
  height: 18px;
  padding: 0 5px;
  color: #fff;
  font-size: 11px;
  line-height: 18px;
  text-align: center;
  background: #f56c6c;
  border-radius: 9px;
  box-sizing: border-box;
}
</style>
